import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';

import { IGlob } from '../../ts/Glob';
import { TableSelect2cols, ITableOptions } from './TableSelect2cols';
import { ITableValue } from '../../../../_common/platform/tsx/tableSelect/Table';
import { TableSelect } from './TableSelect';

const DISPLAY_KEY = 'name';

export interface ISettingsImportValue {
    checkedList?: ITableValue;
    keyList?: string[];
}

export default function SettingsImport(props: {
    value: ISettingsImportValue;
    input: string[];
    valuesHash?;
    useFullTable?: boolean;
    glob: IGlob;

    onChange(value: ISettingsImportValue): void;
}) {
    const getOnValueChangeHandler = (valuesHash) => {
        return (value) => {
            if (typeof props.onChange === 'function') {
                const keyList = _.chain(value)
                    .map((value, key) => {
                        return valuesHash[key][DISPLAY_KEY];
                    })
                    .compact()
                    .value();

                props.onChange({
                    keyList: keyList,
                    checkedList: value
                });
            }
        };
    };

    let valuesHash = props.valuesHash;

    if (valuesHash == null) {
        valuesHash = _.reduce(
            props.input,
            (hash, obj, i) => {
                hash[i] = { name: obj, data: {} };
                return hash;
            },
            {}
        );
    }

    const values = _.range(props.input.length).map((i) => {
        return i.toString();
    });

    const tableOptions: ITableOptions = {
        value: props.value?.checkedList,
        values: values,
        valuesHash: valuesHash,
        displayKey: DISPLAY_KEY,

        onChange: getOnValueChangeHandler(valuesHash)
    };

    let content: React.JSX.Element;

    if (props.useFullTable) {
        content = <TableSelect options={tableOptions} />;
    } else {
        content = <TableSelect2cols options={tableOptions} />;
    }

    return <div className="app-settings-import">{content}</div>;
}
